<template>
  <!-- 标题 -->
  <div class="common__title">
    <span v-if="!hideLine" class="line"></span>
    <span class="title">{{ title }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "new-title",
  props: {
    hideLine: {
      type: Boolean,
      default: () => false,
    },

    title: {
      type: String, //值的类型
      required: true, //是否符合规定
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.common__title {
  display: flex;
  align-items: center;
  line-height: 32px;
}

.common__title .line {
  width: 3px;
  height: 16px;
  background: #1476f9;
  margin-right: 10px;
}

.common__title .title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.common__btn {
  float: right;
  width: 96px;
  line-height: 32px;
  text-align: center;
  background: #1476f9;
  color: #fff;
  font-size: 14px;
  border-radius: 16px;
  margin-left: 740px;
}

.common__btn:hover {
  opacity: .8;
}

.common__title .back {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}

.common__title .back:hover {
  color: #1476f9;
}

.common__title .iconback {
  margin: 0 6px;
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/new-title.vue